import { BaseState } from '@/store/base-state';
import { Brands } from '../types';

export default class BrandsState extends BaseState {
  banner = '';
  design: Brands.Design[] = [];
  brand: Brands.Brand = {
    mission: [],
    style:
    {
      video_path: '',
      preview_video_image_path: '',
      content: null,
      images: [],
      type: {
        name: null,
        slug: null,
      },
    },
  };

  partnership: Brands.PartnerShip[] = [];

  design_title = '';
  design_page_list: Brands.DesingPageList[] = [];
  design_block: Brands.DesingBlock[] = [];
  active_id: string | number | null = null;
}
